import React from 'react'
import Config from '../../Config'

const ButtonPrimary = ({ label, onClick, loadingOnAction }) =>
{
    return (
        <button onClick={onClick} className='wrcButton wrcButton--lightGrey wrcButton--center wrcButton--big wrcButton--start'>
            {loadingOnAction ? Config.strings.dropdowns.loadingSelection :  label }
        </button>
    )
}

export default ButtonPrimary